import { jsx as _jsx } from "react/jsx-runtime";
import { Auth0Provider, } from '@auth0/auth0-react';
import ErrorNetwork from '@hellodarwin/core/lib/components/error/network';
import formatLang from '@hellodarwin/core/lib/features/helpers/format-lang';
import isBrowser from '@hellodarwin/core/lib/features/helpers/is-browser';
import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { useNavigate } from '@hellodarwin/core/lib/features/providers/location-provider';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useCallback, useMemo } from 'react';
import LoginProvider from './login-provider';
export const Auth0ProviderWithNavigate = ({ children, config, EmailVerificationScreenComponent, error, localStorageKeys, requireEmailVerification, resendEmailVerification, }) => {
    var _a;
    const navigate = useNavigate();
    const { selectedLocale } = useLocale();
    const onRedirectCallback = useCallback((appState) => {
        navigate((appState === null || appState === void 0 ? void 0 : appState.returnTo) || (isBrowser ? window.location.pathname : ''));
    }, [navigate]);
    const { app } = usePlatform();
    const customTokenStorageKey = useMemo(() => `auth0_token_${app}`, [app]);
    const { oauthConfig, isError, authorizationParams } = useMemo(() => {
        if (!isBrowser) {
            return {
                oauthConfig: {
                    domain: '',
                    clientId: '',
                },
                isError: true,
                authorizationParams: {},
            };
        }
        const params = new URLSearchParams(window.location.search);
        const locale = formatLang(params.get('locale') || selectedLocale);
        const baseParams = Object.assign({ redirect_uri: isBrowser ? window.location.origin : '', scope: (config === null || config === void 0 ? void 0 : config.scope) || '', audience: (config === null || config === void 0 ? void 0 : config.audience) || '', useRefreshTokens: true, ui_locales: locale, id_token_hint: isBrowser
                ? localStorage.getItem(customTokenStorageKey) || ''
                : '', cacheLocation: 'localstorage' }, (app === 'client' ? {} : { prompt: 'login' }));
        if (app === 'admin') {
            baseParams.prompt = 'consent';
            baseParams.connection = 'google-oauth2';
            baseParams.connection_scope = 'https://www.googleapis.com/auth/drive';
            baseParams.access_type = 'offline';
            baseParams.include_granted_scopes = 'true';
        }
        const authorizationParams = baseParams;
        const oauthConfig = {
            clientId: (config === null || config === void 0 ? void 0 : config.client_id) || '',
            domain: (config === null || config === void 0 ? void 0 : config.domain) || '',
            authorizationParams,
            cookieDomain: isBrowser ? window.location.origin : '',
            onRedirectCallback,
            cacheLocation: 'localstorage',
        };
        const isError = !(config === null || config === void 0 ? void 0 : config.client_id) && !(config === null || config === void 0 ? void 0 : config.domain);
        return { oauthConfig, isError, authorizationParams };
    }, [app, config, customTokenStorageKey, onRedirectCallback, selectedLocale]);
    if (!authorizationParams)
        return;
    if (isError) {
        return _jsx(ErrorNetwork, { errorMessage: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : '' });
    }
    return (_jsx(Auth0Provider, Object.assign({}, oauthConfig, { children: _jsx(LoginProvider, { customTokenStorageKey: customTokenStorageKey, EmailVerificationScreenComponent: EmailVerificationScreenComponent, localStorageKeys: localStorageKeys, requireEmailVerification: requireEmailVerification, resendEmailVerification: resendEmailVerification, children: children }) })));
};
export default Auth0ProviderWithNavigate;
